"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.US_COUNTRY_CODE = exports.AVAILABLE_COUNTRY_CODES = void 0;
var AVAILABLE_COUNTRY_CODES = ['US', 'CA'];
exports.AVAILABLE_COUNTRY_CODES = AVAILABLE_COUNTRY_CODES;
var US_COUNTRY_CODE = 'US';
exports.US_COUNTRY_CODE = US_COUNTRY_CODE;